import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateText,
  EmptyStateSubtext,
} from './EmptyState.styles';
import { Headers } from '@tw/tw-component-library';

interface EmptyStateProps {
  icon?: string;
  title: string;
  subtitle: string;
  isCompact?: boolean;
}

export const EmptyState = ({
  icon = '📁',
  title,
  subtitle,
  isCompact = false,
}: EmptyStateProps) => {
  return (
    <EmptyStateContainer $isCompact={isCompact}>
      <EmptyStateIcon $isCompact={isCompact}>{icon}</EmptyStateIcon>
      <EmptyStateText>
        <Headers headerType="h5">{title}</Headers>
      </EmptyStateText>
      <EmptyStateSubtext>
        <Headers headerType="caption">{subtitle}</Headers>
      </EmptyStateSubtext>
    </EmptyStateContainer>
  );
};


